module.exports = __webpack_public_path__ + "img/human.aaf5a98c.png";